import React from 'react'
import styled from 'styled-components'
import Text from 'core-system/Text/Text'
import { User } from 'redux/user/userTypes'
import { TimeframeOption } from '../adminDashboardTypes'
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone'
import palette from 'core-system/Themes/palette'

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1.5rem;
`

const WelcomeContainer = styled.div`
  display: flex;
  flex-direction: column;
`

const RightContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`

const TimeframeToggle = styled.div`
  display: flex;
  background-color: ${(props) => props.theme.palette.grey.grey100};
  border-radius: 0.5rem;
  padding: 0.25rem;
`

const TimeframeButton = styled.button<{ $isActive: boolean }>`
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: ${(props) =>
    props.$isActive ? props.theme.palette.white : 'transparent'};
  color: ${(props) =>
    props.$isActive
      ? props.theme.palette.text.primary
      : props.theme.palette.text.secondary};
  box-shadow: ${(props) =>
    props.$isActive ? '0 1px 3px rgba(0, 0, 0, 0.1)' : 'none'};

  &:hover {
    color: ${(props) => props.theme.palette.text.primary};
  }
`

const NotificationButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  border: 1px solid ${(props) => props.theme.palette.grey.grey300};
  border-radius: 0.5rem;
  background-color: ${(props) => props.theme.palette.white};
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${(props) => props.theme.palette.grey.grey100};
  }
`

interface AdminDashboardHeaderProps {
  user: User
  selectedTimeframe: TimeframeOption
  onTimeframeChange: (timeframe: TimeframeOption) => void
}

const AdminDashboardHeader = ({
  user,
  selectedTimeframe,
  onTimeframeChange,
}: AdminDashboardHeaderProps) => {
  const capitalize = (str: string) => {
    if (!str) return ''
    return str.charAt(0).toUpperCase() + str.slice(1)
  }

  const userName = user?.firstName ? `${capitalize(user.firstName)}` : 'there'

  const timeframes: TimeframeOption[] = ['7d', '30d', '90d']

  return (
    <Container>
      <WelcomeContainer>
        <Text variant='h2' fontWeight={500} marginBottom={0.5}>
          Welcome, {userName}!
        </Text>
        <Text variant='body1' color={palette.text.secondary}>
          Here's your commuter program overview
        </Text>
      </WelcomeContainer>

      <RightContainer>
        <TimeframeToggle>
          {timeframes.map((tf) => (
            <TimeframeButton
              key={tf}
              $isActive={selectedTimeframe === tf}
              onClick={() => onTimeframeChange(tf)}
            >
              {tf}
            </TimeframeButton>
          ))}
        </TimeframeToggle>

        <NotificationButton>
          <NotificationsNoneIcon
            style={{ color: palette.text.secondary, fontSize: '1.25rem' }}
          />
        </NotificationButton>
      </RightContainer>
    </Container>
  )
}

export default React.memo(AdminDashboardHeader)
